/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import indicatorIcon from '#assets/img/indicators/indicator.svg';
import { CloseOutlined } from '@ant-design/icons';
import { Switch, Tooltip } from 'antd';
import cloneDeep from 'lodash/cloneDeep';

export function ExtraItemsFilter({
  tableConfig,
  indicatorVisible,
  setIndicatorVisible,
  indicators,
  t
}) {
  const [indicatorPercentage, setIndicatorPercentage] = useState(false);

  const leanStatusArray = tableConfig?.find((el) => el.name === 'lean_status');

  if (!leanStatusArray) return null;

  const statusSort = cloneDeep(leanStatusArray.from_values);
  const rest = statusSort.find((el) => el.value === 'Restricted');
  statusSort.splice(3, 0, rest);
  statusSort.shift();

  return (
    <div className="indicators-btn">
      <div className={`indicators ${indicatorVisible ? null : 'hide'}`}>
        <div className="lean">
          <Switch
            checkedChildren="%"
            unCheckedChildren="Un"
            checked={indicatorPercentage}
            onChange={(checked) => {
              setIndicatorPercentage(checked);
            }}
            size="small"
          />
          <div className="lean-info">
            {indicators.total} {t('tasks_only_label')}
          </div>
        </div>
        <div className="status-arr">
          {statusSort.map((el, index) => (
            <div
              key={index}
              className="status-arr-item"
              style={{ color: el.color }}>
              <div>{el.label}</div>
              <div className="count-tasks">
                {indicatorPercentage
                  ? (parseFloat(
                      (100 * (indicators[el.value] || 0)) / indicators.total
                    ).toFixed(1) || 0) + '%'
                  : indicators[el.value] || 0}
              </div>
            </div>
          ))}
        </div>
        <CloseOutlined
          className="close"
          onClick={() => setIndicatorVisible(false)}
        />
      </div>
      <div
        className={`indicators-icon ${indicatorVisible ? 'hidden' : null}`}
        onClick={() => setIndicatorVisible(true)}>
        <Tooltip placement="top" title={t('indicators_label_only')}>
          <img
            width={12}
            src={indicatorIcon}
            style={{ top: -1, position: 'relative' }}
          />
        </Tooltip>
      </div>
    </div>
  );
}
